var doasync = true;



function hasOwnProperty(obj, prop) {
    var proto = obj.__proto__ || obj.constructor.prototype;
    return (prop in obj) &&
        (!(prop in proto) || proto[prop] !== obj[prop]);
}

if (Object.prototype.hasOwnProperty) {
    var hasOwnProperty = function (obj, prop) {
        return obj.hasOwnProperty(prop);
    }
}

function LogosObjectWrapper(object) {

    this.object = object;

    this.relatedObjects = {};

    this.getValueForKey = function (key) {

        for (var i = 0; i < object.Attributes.length; i++) {
            if (object.Attributes[i].key == key)
                return object.Attributes[i].value;
        }

        return "";

    }

    this.getFormattedValueForKey = function (key) {

        for (var i = 0; i < object.FormattedValues.length; i++) {
            if (object.FormattedValues[i].key == key)
                return object.FormattedValues[i].value;
        }

        return "";

    }

    this.getRelatedObjectFromKey = function (key, service) {

        if (hasOwnProperty(this.relatedObjects, key)) {
            return this.relatedObjects[key];
        }
        else {

            var value = this.getValueForKey(key);
            var entityname = value.logical_name;
            var id = value.Id;



        }

    }

    this.setValueForKey = function (key, value) {

        var found = false;

        for (var i = 0; i < object.Attributes.length; i++) {
            if (object.Attributes[i].key == key) {
                object.Attributes[i].value = value;
                found = true;
                break;
            }
        }

        if (!found) {

            object.Attributes.push({ key: key, value: value });

        }

    }

    this.removeAttribute = function (key) {

        for (var i = 0; i < object.Attributes.length; i++) {
            if (object.Attributes[i].key == key) {

                object.Attributes.splice(i, 1);

                break;
            }
        }

    }

    this.keepOnlyReferencedAttributes = function (attributekeys) {

        var newattributes = [];

        for (var i = 0; i < object.Attributes.length; i++) {
            if ($.inArray(object.Attributes[i].key, attributekeys) > -1) {

                newattributes.push(object.Attributes[i]);

            }
        }

        object.Attributes = newattributes;
    }

    this.addComplexAttribute = function (key, logicalname, value) {

        object.Attributes.push({
            key: key,
            value: {
                "__type": "EntityReference:http://schemas.microsoft.com/xrm/2011/Contracts",
                "Id": value,
                "LogicalName": logicalname,
            }
        });

    }

    this.getLogosObject = function () { return this.object; }
}

LogosObjectWrapper.dateFromLogosDate = function (datestr) {
    
    var intpart = parseInt(datestr.match(/\-?[0-9]+/));

    return intpart;
}

LogosObjectWrapper.logosDateFromDate = function (datestr, dateformat) {
    var date = Date.parseExact(datestr, dateformat);

    return {
        __type: "DateTime:http://schemas.microsoft.com/xrm/2011/Contracts",
        Value: date
    };

}

LogosObjectWrapper.getValueForKey = function (object, key) {
    for (var i = 0; i < object.Attributes.length; i++) {
        if (object.Attributes[i].key == key)
            return object.Attributes[i].value;
    }

    return "";
}

LogosObjectWrapper.languages = [];

LogosObjectWrapper.countries = [];

LogosObjectWrapper.functionlevels = [];

LogosObjectWrapper.studylevels = [];

LogosObjectWrapper.genders = [];

LogosObjectWrapper.nationalities = [];

LogosObjectWrapper.annulationReasons = [
    { value: "100000000", text: "Belg" },
    { value: "100000001", text: "EU" },
    { value: "100000002", text: "Andere" }
];

function showErrorString(string) {
   
    alert("Errormessage: " + string);

}



function LogosService(serviceurl) {

    var self = this;

    this.baseserviceUrl = "https://logos-portalservices.azurewebsites.net/";
    //this.baseserviceUrl = "proxy.php?url=";
   // this.baseserviceUrl = "";
    this.serviceUrl = serviceurl;

    this.errorStatus = null;
    this.errorMessage = null;

    this.username = "";
    this.password = "";
     this.go = false;

  



    this.getBasicAuthenticationString = function () {
        

        return "Basic " + base64encode(this.username + ":" + this.password + ":" + (new Date()).getTime());

    }

    this.postToService = function (endpoint, request, successcall) {

        var error = "";
      


        var httpheaders = {
            "CrmOrganization": "logos",
            "x-ClientInfo-Endpoint" : endpoint,
            "x-ClientInfo-Caller" : encodeURIComponent(this.postToService.caller),
            "x-ClientInfo-Browser" : navigator.userAgent,
            "x-ClientInfo-Service" : "postToService"

        };
        
        if(request["action"]) {
            httpheaders["x-ClientInfo-Action"] = request["action"];
        }
        if(request["EntityName"]) {
            httpheaders["x-ClientInfo-EntityName"] = request["EntityName"];
        }



        if (this.username.length > 0 && this.password.length > 0) {
            var authstr = this.getBasicAuthenticationString();

            httpheaders["Authorization"] = authstr;

        }

         


        $.ajax({
            type: "POST",
            url: this.baseserviceUrl + this.serviceUrl + endpoint,
            data: JSON.stringify(request),
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            headers: httpheaders,
            cache: false,
            async: doasync,
            success: function (resp) {
                successcall(resp);
            },
            error: function (e) {
                showErrorString(e.responseText);
                if (doasync)
                    self.setError(e);
                else {
                    error = (e.status + ";" + e.responseText);
                }
            }

        });

        if (!doasync && error.length > 0)
            throw (error);
   

    }

    this.setError = function (e) {
        if (self.errorMessage != null) {
            var error = {
                errorStatus: e.status,
                errorText: e.responseText
            };

            self.errorMessage = error;
            alert("Status: " + e.status + " \r\n"+e.responseText);
        }
    }

    this.getFromService = function (endpoint, successcall) {

        
         var httpheaders = {
            "CrmOrganization": "logos",
            "x-ClientInfo-Endpoint" : endpoint,
            "x-ClientInfo-Service" : "getFromService",
             "x-ClientInfo-Caller" : encodeURIComponent(this.getFromService.caller),
            "x-ClientInfo-Browser" : navigator.userAgent


        };

        $.ajax({

            type: "GET",
            url: this.baseserviceUrl + this.serviceUrl + endpoint,
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            headers: httpheaders,
            cache: false,
            success: function (resp) {
                successcall(resp);
            },
            error: function (e) {
                self.setError(e);
            }

        });

    }

    this.getAuthorisedFromService = function (endpoint, request, successcall) {

       
       
        var httpheaders = {
            "CrmOrganization": "logos",
             "x-ClientInfo-Endpoint" : endpoint,
           
            "x-ClientInfo-Browser" : navigator.userAgent,
            "x-ClientInfo-Caller" : encodeURIComponent(this.getAuthorisedFromService.caller),
             "x-ClientInfo-Service" : "getAuthorisedFromService"
        };

        if (this.username.length > 0 && this.password.length > 0) {
            var authstr = this.getBasicAuthenticationString();

            httpheaders["Authorization"] = authstr;

        }
        jQuery.support.cors = true;
        $.ajax({
            type: "GET",
            //url: this.baseserviceUrl + this.serviceUrl + endpoint,
            url: 'https://logos-portalservices.azurewebsites.net/LogosPortalService.svc/GetLesbedrijven',
            dataType: "json",
            //jsonp: "callback",
            contentType: "application/json; charset=utf-8", //text/plain
            headers: httpheaders,
            cache: false,
            success: function (resp) {
                successcall(resp);
            },
            error: function (e) {
             
                    self.setError(e);
               
            },
            complete: function(xhr, status) {
                
                console.log(status);
            }

        });

       

    }

    this.setErrorMessageObservable = function (errorMessage) {
        self.errorMessage = errorMessage;


    }

}

LogosTransactionService.prototype = new LogosService("TransactionService.svc/");
LogosTransactionService.prototype.constructor = LogosTransactionService;
function LogosTransactionService(errormessage, username, password) {
    var self = this;
    this.setErrorMessageObservable(errormessage);
    this.username = username;
    this.password = password;

  

    this.createSubscription = function (webuserid, accountid, opleidingid, subscribers, success) {

        var subscriptions = [];

        for (var i = 0; i < subscribers.length; i++) {
            subscriptions.push({
                "LogicalName": "new_inschrijving",
                "Attributes": [
                            { key: "new_deelnemerid", value: { __type: "EntityReference:http://schemas.microsoft.com/xrm/2011/Contracts", Id: subscribers[i], LogicalName: "contact", Name: null } },
                            { key: "new_opleidingid", value: { __type: "EntityReference:http://schemas.microsoft.com/xrm/2011/Contracts", Id: opleidingid, LogicalName: "new_opleiding", Name: null } }
                ]
            });

        }


        var request = {
            "Action": "CreateInschrijving",
            "WebUserId": webuserid,
            "AccountId": accountid,
            "OpleidingId": opleidingid,
            "EntityList": subscriptions
        };


        self.postToService("ExecuteInschrijvingTransaction", request, function (resp) {

            if (resp.Success) {
                success(resp.Message);
                } else {
                 
                    showErrorString("Error: " + resp.Message);
                }

        });
    }

    this.createSubscriptionOnWaitingList = function (webuserid, accountid, opleidingssjabloonid, subscribers, success) {

        var subscriptions = [];

        for (var i = 0; i < subscribers.length; i++) {
            subscriptions.push({
                "LogicalName": "new_wachtlijst",
                "Attributes": [
                            { key: "new_contact", value: { __type: "EntityReference:http://schemas.microsoft.com/xrm/2011/Contracts", Id: subscribers[i], LogicalName: "contact", Name: null } },
                            { key: "new_opleidingssjabloonid", value: { __type: "EntityReference:http://schemas.microsoft.com/xrm/2011/Contracts", Id: opleidingssjabloonid, LogicalName: "new_opleidingssjabloon", Name: null } }
                ]
            });

        }


        var request = {
            "Action": "AddToWachtlijst",
            "WebUserId": webuserid,
            "AccountId": accountid,
            "OpleidingssjabloonId": opleidingssjabloonid,
            "EntityList": subscriptions
        };


        self.postToService("ExecuteWachtlijstTransaction", request, function (resp) {

            if (resp.Success) {
                success(resp.Message);
            } else {
                   
                 showErrorString("Error: " + resp.Message);
            }

        });
    }
}

LogosUnauthorizedService.prototype = new LogosService("LogosPortalPublicService.svc/");
LogosUnauthorizedService.prototype.constructor = LogosUnauthorizedService;
function LogosUnauthorizedService() {
    var self = this;

    this.getCountries = function (skip, take, success) {

        var request = {
            "EntityName": "new_country",
            "Skip": skip,
            "Take": take,

              "OrderBy":  "new_naam" + globallang,
            "OrderByAscending": true
        };

        self.postToService("GetCountries", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);
        });

    }

    this.createPortaluser = function (firstname,
            name,
            gender,
            idnumber,
            password,
            email,
            telephone,
            cellphone,
            companyname,
            rsznumber,
            jobtitle,
            language,
            birthdate,
            birthcountry,
            nationality,
            educationlevel,
            comments, success) {

        var fields = [];

        fields.push({ key: "subject", value: "Aanvraag portaalgebruiker: " + name + " " + companyname });
        fields.push({ key: "firstname", value: firstname });
        fields.push({ key: "lastname", value: name });
        fields.push({ key: "new_geslacht", value: { __type: "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", Value: parseInt(gender, 10) } });
        fields.push({ key: "new_rijksregisternummer", value: idnumber });
        fields.push({ key: "new_gewenstpaswoord", value: password });
        fields.push({ key: "new_taal", value: { __type: "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", Value: parseInt(language, 10) } });
        fields.push({ key: "jobtitle", value: jobtitle });
        fields.push({ key: "companyname", value: companyname });
        fields.push({ key: "new_rsznummer", value: rsznumber });
        fields.push({ key: "mobilephone", value: cellphone });
        fields.push({ key: "telephone1", value: telephone });
        fields.push({ key: "emailaddress1", value: email });
        fields.push({ key: "new_opmerking", value: comments });
        fields.push({ key: "new_nationaliteit", value: { __type: "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", Value: parseInt(nationality, 10) } });
        fields.push({ key: "new_diplomaniveau", value: { __type: "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", Value: parseInt(educationlevel, 10) } });
        fields.push({
            key: "new_geboorteland", value: {
                __type: "EntityReference:http://schemas.microsoft.com/xrm/2011/Contracts",
                Id: birthcountry,
                LogicalName: "new_country"
            }
        });
        fields.push({
            key: "new_geboortedatum", value: {
                __type: "DateTime:http://schemas.microsoft.com/xrm/2011/Contracts",
                Value: birthdate
            }
        });


        var user = {};
        user.LogicalName = "lead";
        user.Attributes = fields;

        var request = { "Entity": user };

        self.postToService("createaanvraagportaalgebruiker", request, function (resp) {

            if (resp.Success) {
                success(resp.Message);
            } else {
                    
                showErrorString(resp.Message);
            }

        });
    }
}



LogosAdministrationService.prototype = new LogosService("AdministrationService.svc/");
LogosAdministrationService.prototype.constructor = LogosAdministrationService;
function LogosAdministrationService() {

    var self = this;

    this.translateCredentialsMessage = function (message) {

        switch (message) {

            case "0":
                return "Gebruikersnaam wordt niet herkend";
            case "1":
                return "Paswoord is niet correct";

        }

        return "";

    }

    this.validateCredentials = function (username, password, callback) {

        this.username = username;
        this.password = password;

        var request = { "Username": username, "Password": password };

        self.postToService("ValidateCredentials", request, function (resp) {

            callback(resp.Message == 2, self.translateCredentialsMessage(resp.Message));

        });

    }

    this.isOnline = function (callback) {

        self.getFromService("IsOnline", function (resp) {

            callback(resp.Success, resp.Message);

        });

    }

}

LogosPortalService.prototype = new LogosService("LogosPortalService.svc/");
LogosPortalService.prototype.constructor = LogosPortalService;
function LogosPortalService(errormessage, username, password) {

    var self = this;
    this.setErrorMessageObservable(errormessage);
    this.username = username;
    this.password = password;


    this.countTrainings = function (success) {

        var request = {

        };

        self.postToService("CountPublishedOpleidingen", request, function (resp) {

            success(resp);

        });

    }

    this.getLesbedrijven = function (success) {

       /* var filters =[];
          filters.push({
            key: "new_islesbedrijf",
            value: true,
            conditionoperator: "eq"
        });*/

        var request = {
            "OrderBy": "name"
           /* "EntityName": "account",
            "Skip": 0,
            "Take": 1000,
            "FilterAttributes": filters*/
        };

        self.getAuthorisedFromService("GetLesbedrijven", request, function (resp) {
           
            success(resp);
        });

    }

}


LogosInfrontService.prototype = new LogosService("InfrontPortalService.svc/");
LogosInfrontService.prototype.constructor = LogosInfrontService;
function LogosInfrontService(errormessage, username, password) {

    var self = this;
    this.setErrorMessageObservable(errormessage);
    this.username = Base64.decode(username);
    this.password = Base64.decode(password);




    var contactkeys = ["emailaddress1",
        "mobilephone",
        "telephone1",
        "jobtitle",
        "fax",
        "new_taal",
        "parentcustomerid",
        "new_functieniveau",
        "new_contactrol",
        "birthdate",
        "new_persoon",
        "new_adresbron"];
    var personkeys = ["new_familienaam",
        "new_voornaam",
        "new_rijksregisternummer",
        "new_geslacht",
        "new_geboorteland",
        "new_nationaliteit",
        "new_geboorteplaats",
        "new_geboortedatum",
      
         "new_taal",
        "new_diplomaniveau"];


    this.getNacebelCodes = function (skip, take, success) {

        var request = {
            "EntityName": "new_nace",
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getWebUserAccounts = function (skip, take, success) {

        var request = {
            "EntityName": "account",
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {
            
            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);
        });

    }

    this.getCompanies = function (skip, take, success) {
         var filters =[];
          filters.push({
            key: "businesstypecode",
            value: 100000009,
            conditionoperator: "neq"
        });
        var request = {
            "EntityName": "account",
            "Skip": skip,
            "FilterAttributes": filters,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);
        });

    }

    this.getCompaniesOfGroup = function (id , success) {
         var filters =[];

         filters.push({
             key: "parentaccountid",
             value: id


         });


          filters.push({
            key: "businesstypecode",
            value: 100000009,
            conditionoperator: "neq"
        });
        var request = {
            "EntityName": "account",
            "Skip": 0,
            "FilterAttributes": filters,
            "Take": 1000
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);
        });

    }

   

    

    this.getCountries = function (skip, take, success) {

        var request = {
            "EntityName": "new_country",
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);
        });

    }

    this.getAccountContacts = function (accountid, skip, take, success) {
        
        var request = {
            "EntityName": "contact",
            "FilterAttributes": [
                {
                    key: "parentcustomerid",
                    value: accountid,
                    conditionoperator: "eq"
                },
                {
                    key: "new_contactrol",
                    value: "d8965c1b-c738-e411-825f-005056b02f9c",
                    conditionoperator: "eq"
                },
                {
                    key: "statuscode",
                    value: 1,
                    conditionoperator: "eq"
                }
            ],
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getPeriods = function (skip, take, success) {

        var request = {
            "EntityName": "new_periode",
            "Skip": skip,
            "Take": take,
            "OrderBy": "new_startdatum",
            "OrderByAscending": false
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getYearlyCredits = function (filters, skip, take, success) {

        var request = {
            "EntityName": "new_jaarkrediet",
            "Skip": skip,
            "Take": take,
            "FilterAttributes": filters
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getYearlyCredit = function (yearlycreditid, success) {

        var request = { "EntityName": "new_jaarkrediet", "Id": yearlycreditid };

        self.postToService("Retrieve", request, function (resp) {

            success(resp);

        });

    }

    this.getYearlyCreditSubsidies = function (filters, yearlycreditid, success) {

        filters.push({
            key: "new_jaarkredietid",
            value: yearlycreditid,
            conditionoperator: "eq"
           
        });

        var request = {
            "EntityName": "new_subsidiedossier",
            "FilterAttributes": filters,
             "OrderBy": "new_code",
            "OrderByAscending": true
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getEmployees = function (filters, skip, take, success) {

        filters.push({
            key: "new_contactrol",
            value: "ce7f81f1-572f-e411-825e-005056b02f9c",
            conditionoperator: "eq"
        });

        filters.push({
            key: "statecode",
            value: 0,
            conditionoperator: "eq"
        });

        var request = {
            "EntityName": "contact",
            "FilterAttributes": filters,
            "OrderBy": "lastname",
            "OrderByAscending": true,
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getPersons = function (filters, skip, take, success) {



        var request = {
            "EntityName": "new_persoon",
            "FilterAttributes": filters,
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getAccountEmployees = function (accountid, skip, take, success) {

        var request = {
            "EntityName": "contact",
            "FilterAttributes": [
                {
                    key: "parentcustomerid",
                    value: accountid,
                    conditionoperator: "eq"
                },
                {
                    key: "new_contactrol",
                    value: "ce7f81f1-572f-e411-825e-005056b02f9c",
                    conditionoperator: "eq"
                },
            ],
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getNacebelCode = function (success) {

        var request = { "EntityName": "new_nace" };

        self.postToService("Retrieve", request, function (resp) {

            success(new LogosObjectWrapper(resp));

        });

    }

    this.getTrainingCategories = function (skip, take, success) {

        var request = {
            "EntityName": "new_opleidingscategorie",
            "FilterAttributes": [],
            "Skip": skip,
            "Take": take,
            "FilterAttributes": [
                { key: "statuscode", value: 1, conditionoperator: "eq" }
            ]
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getTrainingCategories2 = function (skip, take, success) {

        var request = {
            "EntityName": "new_opleidingscategorie",
            "FilterAttributes": [],
            "Skip": skip,
            "Take": take,
            
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }
 

    this.getTrainings = function (skip, take, filters, success) {

        filters.push({
            key: "new_startpublicatie",
            value: new Date(),
            conditionoperator: "lt"
        });
        filters.push({
            key: "new_eindepublicatiewebsite",
            value: new Date(),
            conditionoperator: "gt"

        });
        var request = {
            "EntityName": "new_opleiding",
            "FilterAttributes": filters,
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getSessions = function (skip, take, success) {

        var request = {
            "EntityName": "new_sessie",
            "FilterAttributes": [],
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getSessionsByTrainingID = function (trainingid, success) {
        var request = {
            "EntityName": "new_sessie",
            "FilterAttributes": [
                {
                    key: "new_opleidingid",
                    value: trainingid,
                    conditionoperator: "eq"
                }/*,

                {
                    key: "",
                    value: "True"
                }*/

            ],

        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);
        });
    }

    this.getTrainingTemplates = function (skip, take, filters, success) {

        var request = {
            "EntityName": "new_opleidingssjabloon",
            "FilterAttributes": filters,
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getSubsidyTemplates = function (skip, take, filters, success) {

        filters.push({
            key: "statecode",
            value: 0,
            conditionoperator: "eq"
        });

        var request = {
            "EntityName": "new_subsidiedossiersjabloon",
            "FilterAttributes": filters,
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getSubsidyTemplate = function (id, success) {

        var request = { "EntityName": "new_subsidiedossiersjabloon", "Id": id };

        self.postToService("Retrieve", request, function (resp) {

            success(new LogosObjectWrapper(resp));

        });

    }

    this.deleteSubsidyTemplate = function (id, success) {

        var request = {
            "EntityName": "new_subsidiedossiersjabloon",
            "Id": id,
            "NewState": { __type: "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", Value: 1 },
            "NewStatus": { __type: "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", Value: 2 }
        };

        self.postToService("SetState", request, function (resp) {

            success();

        });

    }

    this.getSubsidy = function (id, success) {

        var request = { "EntityName": "new_subsidiedossier", "Id": id };

        self.postToService("Retrieve", request, function (resp) {

            success(new LogosObjectWrapper(resp));

        });

    }

    this.getSubsidyParticipants = function (id, success) {

        var request = {
            "EntityName": "new_deelnemer",
           
            "FilterAttributes": [{ key: "new_subsidiedossier", value: id, conditionoperator: "eq" }, {key: "statecode" , value : 0 , conditionoperator: "eq"}]
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getSubsidizedTrainings = function (id, skip, take, success) {

        var request = {
            "EntityName": "new_deelnemer",
            "FilterAttributes": [{ key: "new_contact", value: id, conditionoperator: "eq" }],
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getTrainingSubscriptions = function (skip, take, filters, success) {

        filters.push({ key: "statuscode", value: [100000005, 1, 100000000, 100000008, 100000006, 100000007, 100000001], conditionoperator: "in" });

        var request = {
            "EntityName": "new_inschrijving",
            "FilterAttributes": filters,
            "Skip": skip,
            "Take": take,
            "OrderBy": "new_opleidingsstartdatum",
            "OrderByAscending": false
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }



    this.getTrainingSubscriptionsWachtlijst = function (skip, take, filters, success) {
       // filters.push({ key: "statuscode", value: [100000005, 1, 100000000, 100000008, 100000006, 100000007, 100000001], conditionoperator: "in" });
        filters.push({ key: "statuscode", value: [1, 100000000, 100000002], conditionoperator: "in" });
        var request = {
            "EntityName": "new_wachtlijst",
            "FilterAttributes": filters,
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getTrainingSubscriptionsForEmployee = function (employeeid, skip, take, success) {
        var request = {
            "EntityName": "new_inschrijving",
            "FilterAttributes": [
                { key: "statuscode", value: [100000005, 1, 100000000, 100000008, 100000006, 100000007, 100000001], conditionoperator: "in" },
                {
                    key: "new_deelnemerid",
                    value: employeeid,
                    conditionoperator: "eq"
                }
            ],
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }
    this.getTrainingWaitingListForEmployee = function (employeeid, skip, take, success) {
        var request = {
            "EntityName": "new_wachtlijst",
            "FilterAttributes": [
                { key: "statuscode", value: [100000005, 1, 100000000, 100000008, 100000006, 100000007, 100000001], conditionoperator: "in" },
                { key: "new_accountid", value: employeeid, conditionoperator: "eq" }
            ],
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }

    this.getObject = function (logicalname, id, success) {

        var request = { "EntityName": logicalname, "Id": accountid };

        self.postToService("Retrieve", request, function (resp) {

            success(new LogosObjectWrapper(resp));

        });

    }

    this.getWebuser = function (username, password, success) {
        var request = {
            "EntityName": "new_websitegebruiker",
            "FilterAttributes": [
                { key: "new_gebruikersnaam", value: username, conditionoperator: "eq" },
                { key: "new_paswoord", value: password, conditionoperator: "eq" }
            ]
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(new LogosObjectWrapper(resp.Entities[0]));

        });
    }

    this.getAccount = function (accountid, success) {

        var request = { "EntityName": "account", "Id": accountid };

        self.postToService("Retrieve", request, function (resp) {

            success(new LogosObjectWrapper(resp));

        });

    }

    this.getContact = function (contactid, success) {

        var request = { "EntityName": "contact", "Id": contactid };

        self.postToService("Retrieve", request, function (resp) {

            success(new LogosObjectWrapper(resp));

        });

    }
    this.getContacts = function (skip, take, filters, success) {



        var request = {
            "EntityName": "Contact",
            "FilterAttributes": filters,
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });

    }
    this.getPerson = function (personid, success) {

        var request = { "EntityName": "new_persoon", "Id": personid };

        self.postToService("Retrieve", request, function (resp) {

            success(new LogosObjectWrapper(resp));

        });

    }

    this.getTrainingTemplate = function (templateid, success) {

        var reques = {
            "EntityName": "new_opleidingssjabloon",
            "Id": templateid
        };

        self.postToService("Retrieve", reques, function (resp) {

            success(new LogosObjectWrapper(resp));

        });

    }



    this.getTraining = function (trainingid, success) {

        var request = {
            "EntityName": "new_opleiding",
            "Id": trainingid
        };

        self.postToService("Retrieve", request, function (resp) {

            success(new LogosObjectWrapper(resp));

        });

    }

    this.updateAccount = function (id, fields, success) {

        var account = {};
        account.LogicalName = "account";
        account.Id = id;
        account.Attributes = fields;

        var request = { "Entity": account };

        self.postToService("Update", request, function (resp) {

            success(resp);

        });

    }

    this.updateContact = function (id, fields, success) {


        var contact = {};
        contact.LogicalName = "contact";
        contact.Id = id;
        contact.Attributes = fields;

        var request = { "Entity": contact };

        self.postToService("Update", request, function (resp) {

            success();

        });

    }

    this.deleteContact = function (id, success) {

        var request = {
            "EntityName": "contact",
            "Id": id,
            "NewState": { __type: "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", Value: 1 },
            "NewStatus": { __type: "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", Value: 2 }
        };

        self.postToService("SetState", request, function (resp) {

            success();

        });

    }

    this.updatePerson = function (id, fields, success) {


        var person = {};
        person.LogicalName = "new_persoon";
        person.Id = id;
        person.Attributes = fields;

        var request = { "Entity": person };
      
        self.postToService("Update", request, function (resp) {

            success();

        });

    }

    this.updateEmployee = function (id, fields, success) {

        var person = {};
        person.Attributes = fields.slice();
        var contact = {};
        contact.Attributes = fields.slice();

        var personwrapped = new LogosObjectWrapper(person);
        var contactwrapped = new LogosObjectWrapper(contact);

        personwrapped.keepOnlyReferencedAttributes(personkeys);
        contactwrapped.keepOnlyReferencedAttributes(contactkeys);

        var personid = contactwrapped.getValueForKey("new_persoon");

        if (personid != "") {

            personid = personid.Id;

            var self = this;
            this.updatePerson(personid, personwrapped.getLogosObject().Attributes, function () {

                contactwrapped.removeAttribute("new_persoon");

                self.updateContact(id, contactwrapped.getLogosObject().Attributes, function () {
                    success();
                });
            });
        }
        else {
            this.updateContact(id, contactwrapped.getLogosObject().Attributes, function () {
                success();
            });
        }
    }

    this.createPerson = function (fields, success) {
        var newfields = fields.slice();

        var person = {};
        person.LogicalName = "new_persoon";
        person.Attributes = newfields;

        var personwrapped = new LogosObjectWrapper(person);
        personwrapped.keepOnlyReferencedAttributes(personkeys);
       /* var i = 0;
        for (i = 0; i < contactkeys.length; i++)
            personwrapped.removeAttribute(contactkeys[i]);*/


        var request = { "Entity": personwrapped.getLogosObject() };

        self.postToService("Create", request, function (resp) {

            if (resp.Success)
                success(resp.Message);

        });
    }

    this.createSubsidyTemplate = function (fields, success) {
        var template = {};
        template.LogicalName = "new_subsidiedossiersjabloon";
        template.Attributes = fields;

        var request = { "Entity": template };

        self.postToService("Create", request, function (resp) {

            if (resp.Success)
                success(resp.Message);

        });
    }

    this.createSubsidySubscription = function (fields, success) {
        var template = {};
        template.LogicalName = "new_deelnemer";
        template.Attributes = fields;

        var request = { "Entity": template };

        self.postToService("Create", request, function (resp) {

            if (resp.Success)
                success(resp.Message);

        });
    }

     this.removeSubsidySubscription = function (id, success) {
        var template = {};
        template.EntityName = "new_deelnemer";
        template.Id = id;
        
        template.NewState =  { __type: "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", Value: 1 };
        template.NewStatus = { __type: "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", Value: 2 };

        var request =  template ;

        self.postToService("SetState", request, function (resp) {

            if (resp.Success)
                success(resp.Message);

        });
    }

    this.getPortaalgebruikerDetails = function(websitegebruiker, success) {
         var request = {
            "EntityName": "new_portaalgebruikerdetail",
            "FilterAttributes":  [ { "key": "new_portaalgebruikerid", "value": websitegebruiker, "conditionoperator": "eq" } ] 
    
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

              success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });


    }
    this.getContactsFromPortaalGebruikerContacts = function(portaalgebruikers,bedrijfid, success) {
        var request = {
            "EntityName": "contact",
            "FilterAttributes": [
                { "key": "contactid", "value": portaalgebruikers, "conditionoperator": "in" },
                { "key": "parentcustomerid", "value": bedrijfid, "conditionoperator": "eq" }
            ]
        };
        self.postToService("RetrieveMultiple", request, function (resp) {

              success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });
    }

    this.createSubsidy = function (fields, success) {
        var dossier = {};
        dossier.LogicalName = "new_subsidiedossier";
        dossier.Attributes = fields;

        var request = { "Entity": dossier };

        self.postToService("Create", request, function (resp) {

            if (resp.Success)
                success(resp.Message);

        });
    }
    this.uploadedListToSubsidy = function (id, success) {

        var request = {
            "EntityName": "new_subsidiedossier",
            "Id": id,
            "NewState": { __type: "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", Value: 0 },
            "NewStatus": { __type: "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", Value: 100000009 }
        };

        self.postToService("SetState", request, function (resp) {

            success();

        });

    }
   

    this.createEmployeeForAccount = function (accountid, fields, success) {
        var newfields = fields.slice();

        var contact = {};
        contact.LogicalName = "contact";
        contact.Attributes = newfields;

        var contactwrapped = new LogosObjectWrapper(contact);

        var request = { "Entity": contact };

        this.createPerson(fields, function (newid) {


            contactwrapped.addComplexAttribute("new_contactrol", "relationshiprole", "ce7f81f1-572f-e411-825e-005056b02f9c");
            contactwrapped.addComplexAttribute("new_persoon", "new_persoon", newid);
            contactwrapped.addComplexAttribute("parentcustomerid", "account", accountid);

            contactwrapped.keepOnlyReferencedAttributes(contactkeys);

            self.postToService("Create", request, function (resp) {

                if (resp.Success)
                    success(resp.Message);

            });

        });
    }

    this.getActiveSubsidizedDossiers = function (filters, skip, take, success) {

        //{ key: "new_lidbedrijfid", value: "50C5290F-4833-E411-825E-005056B02F9C", conditionoperator: "eq" },
        filters.push({ key: "statuscode", value: [100000007, 100000008], conditionoperator: "nin" });

        var request = {
            "EntityName": "new_subsidiedossier",
            "FilterAttributes": filters,
            "Skip": skip,
            "Take": take
        };

        self.postToService("RetrieveMultiple", request, function (resp) {

            success(resp.Entities, resp.Count, resp.MoreRecords, resp.TotalCount);

        });
    }

    this.uploadAttachement= function(fileContent, fileName, subject, mimetype, attached_to_type, attached_to_id , success) {
        var note = {};
        note.LogicalName="annotation";
        note.Attributes = [
               { key: "documentbody", value: fileContent },
               { key: "subject", value: subject },
               { key: "filename", value: fileName },
               { key: "mimetype", value: mimetype },
               { key: "objectid", value: { __type: "EntityReference:http://schemas.microsoft.com/xrm/2011/Contracts", Id: attached_to_id, LogicalName: attached_to_type, Name: null } }
        ];

        var noteWrapped = new LogosObjectWrapper(note);
        var request = { "Entity": noteWrapped.getLogosObject() };
         self.postToService("Create", request, function (resp) {
             if (resp.Success)
                success(resp.Message);
             });
    }


    this.requestExport = function (contactid, company, description, success) {

        var incident = {};
        incident.LogicalName = "incident";
        incident.Attributes = [
            { key: "casetypecode", value: { __type: "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", Value: 2 } },
            { key: "description", value: description },
            { key: "title", value: "export for " + company },
            { key: "caseorigincode", value: { "__type": "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", "Value": 3 } },
            { key: "customerid", value: { __type: "EntityReference:http://schemas.microsoft.com/xrm/2011/Contracts", Id: contactid, LogicalName: "account", Name: null } }
        ];

        var incidentwrapped = new LogosObjectWrapper(incident);

        var request = { "Entity": incidentwrapped.getLogosObject() };

        self.postToService("Create", request, function (resp) {

            if (resp.Success)
                success(resp.Message);

        });
    }



    this.requestSubsidyOrganisation = function (webuserId, companyid, description, success) {
        var gebruikerid = webuserId;
        var incident = {};
        incident.LogicalName = "incident";

        
        incident.Attributes = [
            { key: "casetypecode", value: { __type: "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", Value: 3 } },
            { key: "new_informatielesbedrijf", value: description },
            { key: "new_portaalgebruikerid", value: { __type: "EntityReference:http://schemas.microsoft.com/xrm/2011/Contracts", Id: gebruikerid, LogicalName: "new_websitegebruiker", Name: null }},
            { key: "title", value: "request subsidy organisation" },
            { key: "caseorigincode", value: { "__type": "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", "Value": 3 } },
            { key: "customerid", value: { __type: "EntityReference:http://schemas.microsoft.com/xrm/2011/Contracts", Id: companyid, LogicalName: "account", Name: null } }
        ];

        var incidentwrapped = new LogosObjectWrapper(incident);

        var request = { "Entity": incidentwrapped.getLogosObject() };

        self.postToService("Create", request, function (resp) {

            if (resp.Success)
                success(resp.Message);

        });
    }

    this.requestPasswordForgotten = function (emailaddress, success) {

        var incident = {};
        incident.LogicalName = "incident";
        incident.Attributes = [
            { key: "casetypecode", value: { __type: "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", Value: 1 } },
            { key: "title", value: "paswoord vergeten voor " + emailaddress },
            { key: "caseorigincode", value: { "__type": "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", "Value": 3 } },
            { key: "new_emailadres", value: emailaddress },
            { key: "customerid", value: { __type: "EntityReference:http://schemas.microsoft.com/xrm/2011/Contracts", Id: "5E5EA0D9-572F-E411-825E-005056B02F9C", LogicalName: "account", Name: null } }
        ];

        var incidentwrapped = new LogosObjectWrapper(incident);

        var request = { "Entity": incidentwrapped.getLogosObject() };
        this.username = "tbruyneel";
        this.password = "testpaswoord";
        self.postToService("Create", request, function (resp) {
               this.username = "";
        this.password = "";
            if (resp.Success)
                success(resp.Message);

        });
    }


    this.cancelSubsidy = function (subsidyId, reason, otherreason, success) {

        var incident = {};
        incident.LogicalName = "incident";
        incident.Attributes = [
            { key: "casetypecode", value: { __type: "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", Value: 100000003 } },
            { key: "title", value: "cancel subsidy: " +subsidyId  },
            { key: "description", value: reason },
            { key: "caseorigincode", value: { "__type": "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", "Value": 3 } },
            { key: "new_subsidiedossierid", value: { __type: "EntityReference:http://schemas.microsoft.com/xrm/2011/Contracts", Id:subsidyId , LogicalName: "new_subsidiedossier", Name: null }},
            { key: "new_redenannulatiesubsidiedossier" ,value: { "__type": "OptionSetValue:http://schemas.microsoft.com/xrm/2011/Contracts", "Value": reason } },
            { key: "new_redenannulatiesubsidiedossierandere" , value: otherreason},
            { key: "customerid", value: { __type: "EntityReference:http://schemas.microsoft.com/xrm/2011/Contracts", Id: "5E5EA0D9-572F-E411-825E-005056B02F9C", LogicalName: "account", Name: null } }
        ];
       // console.log(incident);
        var incidentwrapped = new LogosObjectWrapper(incident);

        var request = { "Entity": incidentwrapped.getLogosObject() };

        self.postToService("Create", request, function (resp) {
            //console.log(resp);
            if (resp.Success) {
                success(resp.Message);
                } else {
                    

                }

        });
    }
    

    this.getSucscription = function(guid, success) {
             var request = {
            "EntityName": "new_inschrijving",
            "Id": guid
        };


        /* var request = {
            "EntityName": "new_evaluatie",
            "FilterAttributes": {},

            "Skip": 0,
            "Take": 10
        };*/

        self.postToService("Retrieve", request, function (resp) {
       //   self.postToService("RetrieveMultiple", request, function (resp) {
            success(new LogosObjectWrapper(resp));

        });

    }

    this.submitEvaluation = function(guid, fields, success) {
        


        var evalueatie = {};
        evalueatie.LogicalName = "new_evaluatie";
       
        evalueatie.Attributes = fields;

        var evalueatiewrapped = new LogosObjectWrapper(evalueatie);

        var request = { "Entity": evalueatiewrapped.getLogosObject() };

      
        self.postToService("Create", request, function (resp) {

            success(resp.Message);

        });

    

    }
}

/**
 *
 *  Base64 encode / decode
 *  http://www.webtoolkit.info/
 *
 **/

var Base64 = {

    // private property
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

    // public method for encoding
    encode: function (input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;

        input = Base64._utf8_encode(input);

        while (i < input.length) {

            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output = output +
            this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
            this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);

        }

        return output;
    },

    // public method for decoding
    decode: function (input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;

        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

        while (i < input.length) {

            enc1 = this._keyStr.indexOf(input.charAt(i++));
            enc2 = this._keyStr.indexOf(input.charAt(i++));
            enc3 = this._keyStr.indexOf(input.charAt(i++));
            enc4 = this._keyStr.indexOf(input.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }

        }

        output = Base64._utf8_decode(output);

        return output;

    },

    // private method for UTF-8 encoding
    _utf8_encode: function (string) {
        string = string.replace(/\r\n/g, "\n");
        var utftext = "";

        for (var n = 0; n < string.length; n++) {

            var c = string.charCodeAt(n);

            if (c < 128) {
                utftext += String.fromCharCode(c);
            }
            else if ((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            }
            else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }

        }

        return utftext;
    },

    // private method for UTF-8 decoding
    _utf8_decode: function (utftext) {
        var string = "";
        var i = 0;
        var c = c1 = c2 = 0;

        while (i < utftext.length) {

            c = utftext.charCodeAt(i);

            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            }
            else if ((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i + 1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            }
            else {
                c2 = utftext.charCodeAt(i + 1);
                c3 = utftext.charCodeAt(i + 2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }

        }

        return string;
    }

}

function base64encode(txt) {
    var tmp = "";

    if (typeof (btoa) === 'function') {
        tmp = btoa(txt);
    } else {
        tmp = Base64.encode(txt);
    }

    return tmp;
}
